import { CloseOutlined } from '@ant-design/icons';
import Flex from 'antd/es/flex';
import classNames from 'classnames';
import { FC, MouseEvent } from 'react';
import styles from './CloseModalBtn.module.css';

interface CloseModalBtnProps {
  onClick: (e: MouseEvent<HTMLElement>) => void;
}
const CloseModalBtn: FC<CloseModalBtnProps> = ({ onClick }) => {
  return (
    <Flex
      className={classNames(
        styles['header-btn'],
        'header-action-component trojan-neumorphism-box trojan-neumorphism-box-shadow'
      )}
      onClick={onClick}
      gap="small"
    >
      <CloseOutlined />
    </Flex>
  );
};
export default CloseModalBtn;
